<template>
    <div>

        <div class="">
            <h2 class="text-base tracking-wide p-4 border-b">
                <i class="fa fa-line-chart"></i> Time Series
            </h2>

            <ul class="list-reset overflow-y-auto" style="max-height:50vh;">

                <li class="border-b" v-for="item in series" :key="item.originalCode">
                    <div
                            @click="seriesToggle(item)"
                            class="hover:bg-blue-lighter pl-4 pr-4 pt-6 pb-4 text-black flex justify-between cursor-pointer"
                            :class="{'bg-blue-lightest': isSelected(item)}"
                    >
                        <div class="text-blue-dark">
                            <i class="fa fa-fw"
                               :class="{'fa-check-square': isSelected(item), 'fa-square-o': !isSelected(item)}"
                            ></i>
                        </div>
                        <div class="flex-1 flex xl:flex-row flex-col-reverse">
                            <div class="flex-1 pl-4 pt-4 xl:pt-0">
                                {{ item.description.en }}
                                <div class="mt-4 text-grey-dark hidden xl:block">
                                    {{ item.begin.substring(0,4) }} - {{ item.end.substring(0,4) }}
                                </div>
                            </div>
                            <div class="flex">
                                <div class="w-full pl-4">
                                    <p class="text-xs text-grey-dark uppercase tracking-wide text-right">
                                        {{ item.end.substring(0,4) }}
                                    </p>
                                    <p class="text-black text-xl text-right">
                                        {{ item.latest | number_format }}
                                    </p>
                                    <p class="text-grey-dark tracking-wide text-right">
                                        {{ item.unit }}
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                </li>

                <li v-show="emptyResultSet" class="p-4">
                    no results.
                </li>

                <li v-if="true" class="border-b p-4 h-16" v-for="item in dummies"></li>

            </ul>

            <div class="rounded-b bg-grey-lighter h-16 flex items-center justify-between pr-4">
                <div v-show="!emptyResultSet" class="">
                    <a class="px-4 py-4 flex hover:bg-blue-lighter cursor-pointer"
                         :class="{'bg-blue-lightest': isAllSelected}"
                         @click="toggleAll"
                    >
                        <div class="text-blue-dark">
                            <i class="fa fa-fw"
                               :class="{'fa-check-square': isAllSelected, 'fa-square-o': !isAllSelected}"
                            ></i>
                        </div>
                        <div class="flex w-full justify-between">
                            <div class="pl-4 text-grey-darkest">select all visible</div>
                            <div></div>
                        </div>
                    </a>
                </div>
                <div>
                    <a v-show="hasMore && !loading"
                       class="px-4 py-2 uppercase tracking-wide text-center cursor-pointer border border-black rounded"
                       @click="more"
                    >
                        load more
                    </a>
                    <span v-show="!hasMore && !loading"
                          class="px-4 py-2 uppercase tracking-wide text-center border border-green rounded"
                    >
                        all loaded
                    </span>
                </div>
                <div class="hidden lg:block text-grey-dark">
                    {{ series.length }} / <span v-show="hasMore">?</span> <span v-show="!hasMore">{{ series.length }}</span>
                </div>
            </div>

        </div>

    </div>
</template>

<script>

    export default {

        inject: ['report'],

        props: ['database', 'codes'],

        data() {
            return {
                series: [],
                last: '',
                loading: true,
                hasMore: true,
            }
        },

        watch: {
            'codes.selected': function () {
                this.last = '';
                this.loadData();
            }
        },

        filters: {
            number_format: function (number) {
                return new Intl.NumberFormat('en-GB').format(number);
            },
        },

        computed: {
            emptyResultSet: function () {
                return this.series.length === 0 && !this.loading;
            },
            dummies: function () {
                if (this.loading) {
                    return [0, 1, 2, 3, 4, 5, 6, 7];
                }
                return [];
            },
            isAllSelected: function () {
                let that = this;
                // if there are no series
                if (this.series.length === 0) {
                    return false;
                }

                // find one series that is not selected!
                return this.series.find(function (item) {
                    return !that.isSelected(item);
                }) === undefined;
            }
        },

        methods: {
            loadData: function () {

                let that = this;
                if (that.last === '') {
                    that.series = [];
                }

                that.loading = true;

                window.http.get('/api/v1/indicators/' + this.database + '/series', {
                    params: {
                        list: this.codes.selected.map(function (item) {
                            return item.id;
                        }),
                        last: this.last,
                    },
                }).then((response) => {
                    that.series.push(...response.data.series);
                    that.loading = false;
                    that.hasMore = response.data.hasMore;
                });

            },

            more: function () {
                this.last = this.series[this.series.length - 1].code;
                this.loadData();
            },

            isSelected(series) {
                return this.report.selected.findIndex(function (item) {
                    return item.originalCode === series.originalCode;
                }) !== -1;
            },

            seriesToggle: function (series) {
                // check if already in list
                if (!this.isSelected(series)) {
                    this.report.selected.push(series);
                    return;
                }

                this.report.selected = this.report.selected.filter(function (item) {
                    return item.originalCode !== series.originalCode;
                });
            },

            toggleAll: function () {
                if (!this.isAllSelected) {
                    return this.selectAll();
                }

                let that = this;
                this.series.forEach(function (item) {
                    if (that.isSelected(item)) {
                        that.seriesToggle(item);
                    }
                });
            },

            selectAll: function () {
                let that = this;
                this.series.forEach(function (item) {
                    if (!that.isSelected(item)) {
                        that.report.selected.push(item);
                    }
                })
            },

        },

    }

</script>
